import axios from "axios";
import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useParams } from "react-router-dom";
import { Table } from "../../components/CustomPaginations";
import { dateCol, statusColor, tableStyle } from "../../components/TableStyle";
import { UserConsumer } from "../../UserContext";
import FilterationBar from "./common/FilterationBar";
import { MyTimeSheetStatus_API } from "./MyTimeSheetStatus_API";
import moment from "moment";
import { APIDateFormat } from "../Dashboard/DashboardVariables";
import { Routes } from "../../configurations/config";
import { GlobalPaginationSize } from "../../components/GlobalPaginationSize";
import ActionFormatter from "./common/ActionFormatter";
import ScoreHeader from "./common/ScoreHeader";
import ButtonLoader from "../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../ticketModule/variables/ListingVariables";

function MyTimeSheetsStatusView() {
	let token,
		joiningDate = null;
	const defaultSorted = [
		{
			dataField: "weekStart",
			order: "desc",
		},
	];
	const months = [
		{ value: 0, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];
	const status = [
		{ value: -1, label: "All" },
		{ value: 4, label: "Approved" },
		{ value: 1, label: "In Progress" },
		{ value: 0, label: "Not Created" },
		{ value: 5, label: "Rejected" },
		{ value: 2, label: "Saved" },
		{ value: 3, label: "Submitted" },
	];

	const scoreList = [
		{ value: 0, label: "All" },
		{ value: 1, label: "1 - Failed to Meet Expectations" },
		{ value: 2, label: "2 - Meeting Expectations -" },
		{ value: 3, label: "3 - Meeting Expectations" },
		{ value: 4, label: "4 - Meeting Expectations +" },
		{ value: 5, label: "5 - Meeting and Exceeding Expectations" },
		{ value: -1, label: "None" },
	];

	const params = useParams();
	const date = new Date();
	const currentMonth = months[date.getMonth() + 1];
	const currentYear = date.getFullYear();
	const [flag, setFlag] = useState(false);
	const [pageNum, setPageNum] = useState(1);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [averageScrore, setAverageScore] = useState(null);
	const [yearsList, setYearsList] = useState([]);
	const [pagerData, setPagerData] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [isLoading, setIsLoading] = useState(true);
	const [myTimeSheetData, setMyTimeSheetData] = useState([]);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const [selectedScore, setSelectedScore] = useState(
		sessionStorage.getItem("MyTimesheetStatus")
			? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[3]
				? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[3]
				: scoreList[0]
			: scoreList[0]
	);
	const [selectedStatus, setSelectedStatus] = useState(
		sessionStorage.getItem("MyTimesheetStatus")
			? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[2]
				? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[2]
				: status[0]
			: status[0]
	);
	const [selectedMonth, setSelectedMonth] = useState(
		sessionStorage.getItem("MyTimesheetStatus")
			? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[1]
				? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[1]
				: currentMonth
			: currentMonth
	);
	const [selectedYear, setSelectedYear] = useState(
		sessionStorage.getItem("MyTimesheetStatus")
			? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[0]
				? JSON.parse(sessionStorage.getItem("MyTimesheetStatus"))[0]
				: {
						value: currentYear,
						label: currentYear,
				  }
			: {
					value: currentYear,
					label: currentYear,
			  }
	);

	const customActionFormatter = (row) => (
		<ActionFormatter weekStart={row.weekStart} />
	);
	const customScoreHeader = () => <ScoreHeader />;

	const getColumns = [
		{
			dataField: "supervisorName",
			text: "Supervisor Name",
			sort: true,
		},
		{
			dataField: "weekStart",
			text: "Week Start",
			sort: true,
			formatter: dateCol,
		},

		{
			dataField: "weekEnd",
			text: "Week End",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "submittedDate",
			text: "Submittted Date",
			sort: true,
			formatter: (cell, row) => {
				if (row.submittedDate) return dateCol(row.submittedDate);
				else return "";
			},
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			style: (cell, row) => {
				if (row.status === "Saved") {
					return { color: "#ffbe5c" };
				} else {
					return statusColor(row.status);
				}
			},
		},
		{
			dataField: "score",
			headerFormatter: () => customScoreHeader(),
			text: "Score",
			sort: true,
			formatter: (row, cell) => {
				return cell.numericScore === -1
					? " (" + cell.score + ")"
					: cell.numericScore + " (" + cell.score + ")";
			},
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => customActionFormatter(row),
		},
	];
	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };

		if (params.id) {
			//redirected from my dashboard
			let redirectedStatus = status.find((x) => x.label === params.id);
			setSelectedStatus(redirectedStatus);
			setSelectedMonth(months[0]);
			//get default api list
			axios
				.get(
					`${
						MyTimeSheetStatus_API.GetMyTimeSheetStatusList
					}?PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${
						sortBy.dataField
					}_${sortBy.order}&Status=${
						redirectedStatus.value
					}&Month=${0}&year=${selectedYear.value}`,
					{
						headers: header,
					}
				)
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setAverageScore(
							calculateAverageScore(
								res.data.numericAverageScore,
								res.data.averageScore
							)
						);
						setFlag(true);
						setMyTimeSheetData(res.data.timesheets);
					}
				});
		} else {
			//get default api list
			axios
				.get(
					`${MyTimeSheetStatus_API.GetMyTimeSheetStatusList}?PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&year=${selectedYear.value}`,
					{
						headers: header,
					}
				)
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setAverageScore(
							calculateAverageScore(
								res.data.numericAverageScore,
								res.data.averageScore
							)
						);
						setFlag(true);
						setMyTimeSheetData(res.data.timesheets);
					}
				});
		}
		//To auto start from joining date till current year
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate != currentYear + 1);
		setYearsList(list);

		setApiTokenHeader(header);
	}, []);

	const calculateAverageScore = (numericAverageScore, averageScore) => {
		if (numericAverageScore != -1)
			return `${numericAverageScore.toFixed(2)}
		${averageScore != "" ? " (" + averageScore + ")" : ""}`;
		else return "N/A";
	};
	const updateTableData = (year, month, status, score) => {
		setIsLoading(true);
		axios
			.get(
				`${MyTimeSheetStatus_API.GetMyTimeSheetStatusList}?PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&Year=${year}&Month=${month}&Status=${status}&Score=${score}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setAverageScore(
						calculateAverageScore(
							res.data.numericAverageScore,
							res.data.averageScore
						)
					);
					setFlag(true);
					setMyTimeSheetData(res.data.timesheets);
				}
			});
	};
	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios({
			url: `${MyTimeSheetStatus_API.ExportToExcel}?Status=${selectedStatus.value}&Month=${selectedMonth.value}&year=${selectedYear.value}&SortBy=${sortBy.dataField}_${sortBy.order}`,
			method: "GET",
			responseType: "blob",
			headers: apiTokenHeader,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "myTimeSheetStatus.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					MyTimeSheetStatus_API.GetMyTimeSheetStatusList
				}?PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&Status=${selectedStatus.value}&Month=${
					selectedMonth.value
				}&year=${selectedYear.value}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setAverageScore(
						calculateAverageScore(
							res.data.numericAverageScore,
							res.data.averageScore
						)
					);
					setFlag(true);
					setMyTimeSheetData(res.data.timesheets);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${MyTimeSheetStatus_API.GetMyTimeSheetStatusList}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&year=${selectedYear.value}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${MyTimeSheetStatus_API.GetMyTimeSheetStatusList}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${selectedStatus.value}&Month=${selectedMonth.value}&year=${selectedYear.value}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: apiTokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setAverageScore(
							calculateAverageScore(
								res.data.numericAverageScore,
								res.data.averageScore
							)
						);
						setFlag(true);
						setMyTimeSheetData(res.data.timesheets);
					}
				});
		}
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("MyTimesheetStatus"))
			obj = JSON.parse(sessionStorage.getItem("MyTimesheetStatus"));
		if (property === "year") obj[0] = value;
		else if (property === "month") obj[1] = value;
		else if (property === "status") obj[2] = value;
		else if (property === "score") obj[3] = value;
		sessionStorage.setItem("MyTimesheetStatus", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			window.open(
				`${Routes.MyTimeSheetsStatus}?week=${moment(
					row.weekStart
				).format(APIDateFormat)}`,
				"_blank"
			);
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="My Timesheet Status"
								headerBorder="false"
							/>

							<FilterationBar
								years={yearsList}
								selectedYear={selectedYear}
								onYearChange={(value) => {
									setSelectedYear(value);
									storeFiltersStates(value, "year");
									updateTableData(
										value.value,
										selectedMonth.value,
										selectedStatus.value,
										selectedScore.value
									);
								}}
								months={months}
								selectedMonth={selectedMonth}
								onMonthChange={(value) => {
									setSelectedMonth(value);
									storeFiltersStates(value, "month");
									updateTableData(
										selectedYear.value,
										value.value,
										selectedStatus.value,
										selectedScore.value
									);
								}}
								scoreList={scoreList}
								selectedScore={selectedScore}
								onScoreChange={(obj) => {
									setSelectedScore(obj);
									storeFiltersStates(obj, "score");
									updateTableData(
										selectedYear.value,
										selectedMonth.value,
										selectedStatus.value,
										obj.value
									);
								}}
								status={status.sort((a, b) =>
									a.label.localeCompare(b.label)
								)}
								selectedStatus={selectedStatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									storeFiltersStates(value, "status");
									updateTableData(
										selectedYear.value,
										selectedMonth.value,
										value.value,
										selectedScore.value
									);
								}}
							/>
							<div className="d-flex justify-content-end my-2">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									disabled={
										!myTimeSheetData.length ||
										showBtnLoading
									}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={showBtnLoading}
								/>
							</div>
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"token"}
											columns={getColumns}
											items={myTimeSheetData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											flag={flag}
											flagTitle={"Average Score"}
											flagCount={averageScrore}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default MyTimeSheetsStatusView;
